import { ReactNode } from "react";
import classNames from "classnames";

type TabId = string | number;

type Tab<TId extends TabId> = {
  id: TId;
  label: ReactNode;
};

type TabsProps<TId extends TabId> = {
  activeTab: TId;
  tabs: Tab<TId>[];
  onTabClick: (id: TId) => void;
  className?: string;
};

/**
 * Renders a set of tabs based on the provided data.
 *
 * By default, tabs will wrap as they run out of horizontal space.
 */
const Tabs = <TId extends TabId>({
  tabs,
  activeTab,
  onTabClick,
  className,
}: TabsProps<TId>) => {
  return (
    <ul
      className={classNames(
        "nav nav-tabs align-items-end flex-nowrap overflow-auto",
        className,
      )}
    >
      {tabs.map((x) => (
        <li key={x.id}>
          <button
            className={classNames("nav-link", {
              active: activeTab === x.id,
            })}
            onClick={() => onTabClick(x.id)}
          >
            {x.label}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default Tabs;
